import { isGuid, normalizeCnj, validCnj } from '../legal-rag/juditDocumentHelpers.js'

export function prazoProcessNumber(prazo) {
  return [prazo?.numeroProcesso, prazo?.processo]
    .find((value) => validCnj(value))?.trim() || ''
}

export function localProcessConsultations(payload, numeroProcesso) {
  const number = normalizeCnj(numeroProcesso)
  if (!payload || typeof payload.numeroProcesso !== 'string' || normalizeCnj(payload.numeroProcesso) !== number || !Array.isArray(payload.consultas) ||
    payload.maisConsultas != null && typeof payload.maisConsultas !== 'boolean' ||
    payload.consultas.some((consulta) => !consulta || !isGuid(consulta.consultaId) || typeof consulta.numeroProcesso !== 'string' ||
      normalizeCnj(consulta.numeroProcesso) !== number || !Array.isArray(consulta.anexos))) {
    throw new Error('A lista recebida não corresponde ao processo deste card. Recarregue os documentos locais.')
  }
  return payload.consultas
}

export function selectedProcessConsultation(consultas, consultaId, maisConsultas = false) {
  if (consultaId) return consultas.find((item) => item.consultaId === consultaId) || null
  return !maisConsultas && consultas.length === 1 ? consultas[0] : null
}

export function processDocumentText(payload, consulta, anexo) {
  if (!payload || payload.documentoId !== anexo.documentoId || payload.versao !== anexo.documentoVersao ||
    payload.textoSha256 !== anexo.textoSha256 || payload.estadoExtracao !== 'EXTRAIDO' ||
    !Array.isArray(payload.paginas) || payload.paginas.length !== anexo.quantidadePaginas ||
    payload.paginas.some((pagina, index) => pagina.numero !== index + 1 || typeof pagina.texto !== 'string')) {
    throw new Error('O texto ou a versão do documento mudou. Recarregue os documentos locais e confira novamente.')
  }
  return { ...payload, titulo: anexo.titulo || 'Documento do processo', consultaId: consulta.consultaId }
}

export function processDocumentError(response) {
  if ([401, 403].includes(response?.status)) return 'Sua sessão ou permissão não permite ler estes documentos.'
  if (response?.status === 404) return 'Documento não encontrado para seu acesso. Recarregue os documentos locais.'
  if (response?.status === 409) return 'O documento mudou. Recarregue a lista e confira novamente.'
  return 'Não foi possível ler os documentos locais. Tente novamente.'
}

export function processDraftLocation(numeroProcesso) {
  return { pathname: '/base-juridica/configuracoes', search: '?secao=testar',
    state: { processoContexto: { numeroProcesso, buscarDocumentos: true } } }
}
